<template>
    <Layout>
        <div class="sticky-header">
            <div class="page-head">
                <h4 class="mt-2 mb-2">
                    <a @click="$router.go(-1)" class="mr-3 cursor-pointer"> <i class="fa fa-arrow-left"></i></a>
                    Pagos disponibles
                </h4>
            </div>
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <div class="searchResult" v-if="!pagoExitoso">
                        <div class="row" v-if="Object.keys(requerimientos).length > 0">
                            <div v-for="item in requerimientos" class="col-12 mb-2 resultItem text-center">
                                <div>
                                    <div>
                                        <h5><b>Monto:</b> {{ item.moneda }} {{
                                                Numbro((item.monto) ? item.monto : 0).format({
                                                    thousandSeparated: true,
                                                    mantissa: 2
                                                })
                                            }}</h5>
                                    </div>
                                    <div class="mt-2">
                                        <b>Requerimiento No. </b> {{ item.requerimiento }}
                                    </div>
                                    <div>
                                        <b>Pago No.</b> {{ item.numero_pago }}
                                    </div>
                                    <div class="text-danger">
                                        <b>Días vencido: </b> {{ item.dias_vencido }}
                                    </div>
                                </div>
                                <div class="mt-4 text-center" v-if="!showPago">
                                    <button class="btn btn__guardar btn-sm" @click="pagoLink">Realizar pago</button>
                                </div>
                                <div v-else>
                                    <div class="col-12 mt-3">
                                        <hr>
                                        <div class="mt-3">
                                            <div class="font-weight-bold">Pagar con tarjeta</div>
                                            <img src="assets/images/visamaster.png" alt="" style="max-width: 100px">
                                        </div>
                                        <div>
                                            <div class="mt-4 text-left">
                                                <div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tarjeta No.</label>
                                                                <input type="tel" class="form-control" name="cardNumber" placeholder="---- ---- ---- ----" data-card-field v-model="cardNumberMask" maxlength="19">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Nombre en tarjeta</label>
                                                                <input type="text" class="form-control" name="cardName" placeholder="Escribe aquí" data-card-field v-model="cardName">
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="form-group">
                                                                <label>Expiración</label>
                                                                <select class="form-control" id="cardExpirationMonth" v-model="cardMonth" data-card-field>
                                                                    <option value disabled selected>Mes</option>
                                                                    <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">{{ generateMonthValue(n) }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="form-group pl-2">
                                                                <label>&nbsp;</label>
                                                                <select class="form-control" id="cardExpirationYear" v-model="cardYear" data-card-field>
                                                                    <option value disabled selected>Año</option>
                                                                    <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">{{ $index + minCardYear }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-4">
                                                            <div class="form-group pl-2">
                                                                <label>CVV</label>
                                                                <input type="password" class="form-control" id="cardCvv" aria-describedby="Card CVV" placeholder="---" data-card-field v-model="cardCvv" pattern="[0-9]*" inputmode="numeric">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12 col-sm-4">
                                                        <div class="form-group">
                                                            <label>Cuotas</label>
                                                            <select class="form-control" id="cuotasPago" v-model="cuotas" data-card-field>
                                                                <option value="0">Pago de contado</option>
                                                                <option value="3">3 Cuotas</option>
                                                                <option value="6">6 Cuotas</option>
                                                                <option value="10">10 Cuotas</option>
                                                                <option value="12">12 Cuotas</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-4">
                                                        <div class="form-group">
                                                            <label>Teléfono</label>
                                                            <input type="text" class="form-control" placeholder="Escribe aquí" data-card-field v-model="telefono"  v-maska data-maska="########">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-4">
                                                        <div class="form-group">
                                                            <label>Correo electrónico</label>
                                                            <input type="text" class="form-control" placeholder="Escribe aquí" data-card-field v-model="correo">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mt-4 text-center">
                                                    <button class="btn btn__actualizar" @click="realizarPago(item.requerimiento)" :disabled="procesando">
                                                        <i class="fa fa-check-circle"></i>
                                                        <span v-if="procesando">Procesando...</span>
                                                        <span v-else>Realizar pago</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="text-center text-muted">
                            <div v-if="msg !== ''">
                                {{ msg }}
                            </div>
                            <div v-else>
                                No se encontraron requerimientos
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="text-center mt-5">
                            <h5>Tu pago ha sido realizado con éxito</h5>
                        </div>
                        <div class="reporte-btns-container">
                            <div class="col-12 mb-3 btn__reporte">
                                <button @click="printFactura" class="btn item-reporte">Descargar Factura</button>
                            </div>
                            <div class="col-12 mb-3 btn__reporte">
                                <button @click="printVoucher" class="btn item-reporte">Descargar Voucher</button>
                            </div>
                            <div class="col-12 mb-3 btn__reporte">
                                <button @click="$router.push('/mis-pagos')" class="btn item-reporte">Realizar otra consulta</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/LayoutPublico.vue";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";
import Swal from "sweetalert2";
import {CONFIG} from "src/config";
import {requestGuardMixin} from "src/core/requestGuard";

export default {
    mixins: [requestGuardMixin],
    props: [],
    components: {
        Pago,
        Layout,
        InicioPago,
    },
    data() {
        return {
            Valid: {},
            requerimientos: {},
            pagar: 0,
            tipoPago: '',
            nit: '',
            nombre: '',
            direccion: '',
            polizaNo: '',
            pagoExitoso: false,

            pagandoref: 0,
            pagosToApply: {},
            msg: "",

            // pago
            showPago: true,
            correo: '',
            telefono: '',
            cardNumberMask: '',
            cardNumber: '',
            cardName: '',
            cardMonth: '',
            minCardMonth: '',
            cardYear: '',
            cardCvv: '',
            minCardYear: new Date().getFullYear(),
            cuotas: 0,

            // impresion
            idPago: 0,
            idPagoLog: 0,
        };
    },
    computed: {
        /*cardNumber() {
            if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1
            return 1
        },*/
    },
    watch: {
        // whenever question changes, this function will run
        cardNumberMask: function (valor) {
            this.cardNumberMask = valor.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ').trim();
            this.cardNumber = this.cardNumberMask.replace(/\W/gi, '');
        }
    },
    mounted() {

        const self = this;
        this.getRequerimientos();

    },
    methods: {
        Numbro,
        dayjs,
        activarPagandoRef(data) {
            this.pagandoref = data;
        },
        cancelarPago() {
            this.pagar = 0;
        },
        pagoLink() {
            alert('El pago ha sido desactivado');
        },
        generateMonthValue(n) {
            return n < 10 ? `0${n}` : n
        },
        getRequerimientos() {
            const self = this;
            const poliza = self.$route.params.poliza;

            if (!poliza || parseInt(poliza, 10) <= 0) {
                return;
            }

            if (!self.iniciarProceso()) {
                return;
            }

            API.send('GET', 'consulta/requerimientos/poliza/publico?p=' + encodeURIComponent(poliza), null,
                function (response) {
                    if (response.status) {
                        self.requerimientos = (typeof response.data === "object") ? response.data : {};
                    } else {
                        self.msg = response.msg;
                    }
                    self.finalizarProceso();
                },
                function () {
                    self.msg = 'Error de conexión, por favor intente de nuevo';
                    alert(self.msg);
                    self.finalizarProceso();
                },
                {disableLoading: true, singleFlight: true});
        },
        resetPay() {
            this.cardNumber = '';
            this.cardName = '';
            this.cardMonth = '';
            this.cardYear = '';
            this.cardCvv = '';
            this.minCardYear = new Date().getFullYear();
            this.cuotas = 0;
        },
        realizarPago(requerimiento) {
            const self = this;

            if (!self.iniciarProceso()) {
                return;
            }

            API.send('POST', 'cobros/pago/publico', {
                    cardNumber: self.cardNumber,
                    cardName: self.cardName,
                    cardCvv: self.cardCvv,
                    cardMonth: self.cardMonth,
                    cardYear: self.cardYear,
                    cuotas: self.cuotas,
                    correo: self.correo,
                    telefono: self.telefono,
                    requerimiento: requerimiento,
                    poliza: self.$route.params.poliza,
                },
                function (response) {
                    if (response.status) {
                        self.idPago = response.data.pa;
                        self.idPagoLog = response.data.pl;
                        self.pagoExitoso = true;
                        Swal.fire({
                            icon: "success",
                            title: "Operación exitosa",
                            text: response.msg,
                        });
                    }
                    else {
                        response.msg = 'No fue posible realizar la consulta de tu poliza, por favor comunicante al 2420-333, Departamento de Cobros o ingresa al siguiente link: https://roble.io/A24uM9 para dejar tu consulta';
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: response.msg,
                        });
                    }
                    self.finalizarProceso();
                },
                function () {
                    self.msg = 'No fue posible realizar la consulta de tu poliza, por favor comunicante al 2420-333, Departamento de Cobros o ingresa al siguiente link: https://roble.io/A24uM9 para dejar tu consulta';
                    self.finalizarProceso();
                },
                {disableLoading: true, singleFlight: true});
        },
        printFactura() {
            const self = this;

            if (!self.iniciarProceso()) {
                return;
            }

            API.send('POST', 'cobros/pago/publico/factura', {
                    idPago: self.idPago
                },
                function (response) {
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                    self.finalizarProceso();
                },
                function () {
                    self.msg = 'No fue posible realizar la consulta de tu poliza, por favor comunicante al 2420-333, Departamento de Cobros o ingresa al siguiente link: https://roble.io/A24uM9 para dejar tu consulta';
                    self.finalizarProceso();
                },
                {disableLoading: true, singleFlight: true});
        },
        printVoucher() {
            const self = this;

            if (!self.iniciarProceso()) {
                return;
            }

            API.send('POST', 'cobros/pago/publico/voucher', {
                    idPago: self.idPagoLog
                },
                function (response) {
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                    self.finalizarProceso();
                },
                function (response) {
                    self.msg = response.msg;
                    self.finalizarProceso();
                },
                {disableLoading: true, singleFlight: true});
        },
    },
};
</script>
